import { RootAttribute } from "@/stores/EngineStore/enums/RootAttribute.ts";

/**
 * Function to get the API URL based on the App URL
 */
export const getAPIUrl = (): string => {
  const appURL = window.location.href;
  let apiURL = import.meta.env.VITE_API_URL;

  const divElement = document.getElementById("bookingEngine");
  const dataAttributeApiUrl = divElement?.getAttribute(`data-${RootAttribute.ApiUrl}`);

  if (appURL) {
    const orgApiUrl = extractSubdomain(appURL);

    if (orgApiUrl && !orgApiUrl.includes("localhost") && !orgApiUrl.includes("127")) {
      apiURL = replaceSubdomain(apiURL, orgApiUrl);
    }

    if (dataAttributeApiUrl) {
      apiURL = dataAttributeApiUrl;
    }
  }

  return apiURL;
};

/**
 * Replaces the subdomain in the API URL
 *
 * @example
 * replaceSubdomain("https://swen.api.hiswen.com/", "camp1") // "https://camp1.api.hiswen.com/"
 * replaceSubdomain("https://camp1.api.hiswen.com/", "swen") // "https://swen.api.hiswen.com/"
 */
export const replaceSubdomain = (apiURL: string, subdomain: string): string => {
  if (!subdomain) return apiURL;

  return apiURL.replace(/(\w+)(\.api[.-])/, `${subdomain}$2`);
};

/**
 * Extracts the subdomain from the App URL
 *
 * @example
 * https://swen.booking-test.hiswen.com/ --> swen
 * https://camp1.booking-222.hiswen.com/ --> camp1
 * https://hotel2.booking.hiswen.com/ --> hotel2
 */
export const extractSubdomain = (url: string): string | null => {
  // Regular expression pattern to match the subdomain
  const pattern = /^https?:\/\/([^/.]+)/;

  // Match the pattern in the URL
  const match: RegExpExecArray | null = pattern.exec(url);

  // Extract and return the subdomain
  if (match) {
    return match[1];
  } else {
    return null;
  }
};
